import {
  ArrowTopRightOnSquareIcon,
  PaperAirplaneIcon,
} from '@heroicons/react/24/outline';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CommentPopup from './CommentPopup';
import { setUserCommentsAction } from '../../reduxstore/actions/authActions';

const CommentBox = ({ heading }) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state?.authReducer?.user);
  const comments = useSelector((state) => state?.authReducer?.user?.comments);
  const commentsData = comments[heading];
  const commentBoxRef = useRef(null);
  const [comment, setComment] = useState('');
  const [commentPopup, setCommentPopup] = useState({ visible: false });

  const handleCommentSubmit = () => {
    // setting comment data
    const newComment = {
      comment: comment,
      user: 'Supplier',
    };

    const updatedComments = {
      ...comments,
      [heading]: [...commentsData, newComment],
    };

    dispatch(setUserCommentsAction(updatedComments));
    setComment('');
  };

  useEffect(() => {
    // Scroll to the bottom of the comment box when new comments are added
    if (commentBoxRef.current) {
      commentBoxRef.current.scrollTop = commentBoxRef.current.scrollHeight;
    }
  }, [commentsData]);

  return (
    <div className="min-w-screen mt-5 ">
      {commentsData ? (
        <div className="flex flex-col px-5 pb-8 bg-neutral-200 rounded-2xl">
          <div className="py-3 flex justify-end">
            <ArrowTopRightOnSquareIcon
              className="h-6 w-6"
              onClick={() =>
                setCommentPopup({
                  visible: true,
                  section: heading,
                })
              }
            />
          </div>
          <div
            className="pb-3 max-h-[200px] overflow-y-auto commentBoxScroller"
            ref={commentBoxRef}
          >
            {commentsData &&
              commentsData.map((comment, index) => (
                <div className="px-5 py-2 rounded-2xl">
                  <div className="flex flex-row space-x-3">
                    <img
                      className="h-12 w-12 rounded-full"
                      src={
                        comment.user === 'MakerSharks'
                          ? '/logo1.svg'
                          : user?.picture
                      }
                      alt="user"
                    />
                    <p className="">
                      <p className="text-[#28384E] font-bold">{comment.user}</p>
                      <div className="text-[13.33px] mt-2">
                        {comment.comment}
                      </div>
                    </p>
                  </div>
                </div>
              ))}
          </div>
          <div className="flex flex-row px-5 py-2 bg-white border border-neutral-200 rounded-2xl items-center">
            <div>
              <img
                className="h-12 w-12 rounded-full"
                src={user?.picture}
                alt="user"
              />
            </div>
            <div className="flex-grow px-5">
              <input
                type="text"
                name="comment"
                id="comment"
                className="relative px-2 py-1 bg-white w-full rounded-full hover:cursor-pointer text-[13.33px] font-normal focus:outline-none placeholder:text-black sm:text-sm sm:leading-6 placeholder:italic placeholder:text-[13.33px] "
                value={comment}
                onChange={(e) => setComment(e.target.value)}
                placeholder="Add a suggestion or comment..."
              />
            </div>
            <PaperAirplaneIcon
              className="h-6 w-6 hover:cursor-pointer"
              onClick={() => handleCommentSubmit()}
            />
          </div>
        </div>
      ) : (
        <div className="flex flex-row px-5 py-2 border border-neutral-200 rounded-2xl items-center">
          <div>
            <img
              className="h-12 w-12 rounded-full"
              src={user?.picture}
              alt="user"
            />
          </div>
          <div className="flex-grow px-5">
            <input
              type="text"
              name="comment"
              id="comment"
              className="relative px-2 py-1 bg-white w-full rounded-full hover:cursor-pointer text-[13.33px] font-normal focus:outline-none placeholder:text-black sm:text-sm sm:leading-6 placeholder:italic placeholder:text-[13.33px]"
              value={comment}
              onChange={(e) => setComment(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleCommentSubmit();
                }
              }}
              placeholder="Add a suggestion or comment..."
            />
          </div>
          <PaperAirplaneIcon
            className="h-6 w-6 hover:cursor-pointer"
            onClick={() => handleCommentSubmit()}
          />
        </div>
      )}

      {commentPopup.visible && (
        <CommentPopup
          setCommentPopup={setCommentPopup}
          Section={commentPopup.section}
        />
      )}
    </div>
  );
};

export default CommentBox;
